import horizontal_blue_bar from '../assets/images/horizontal_blue_bar.png';
import first_image from '../assets/images/main.svg';
import mail from '../assets/images/mail.svg';
import call from '../assets/images/call.svg';
import card from '../assets/images/card.svg';
import relax from '../assets/images/relax.svg';
import box from '../assets/images/box1.png';
import banner from '../assets/images/banner.svg';
import insurance_image from '../assets/images/insurance1.png';
import ReCAPTCHA from 'react-google-recaptcha';
import hdfc from '../assets/images/hdfc.png';
import axios from 'axios';
import React from 'react';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { InstanceWithAuth, CLAIM } from 'api/routes';

import Swal from 'sweetalert2';
import { Helmet } from 'react-helmet-async';

function Claim() {
  const [comapnyList, setCompanyList] = useState([]);
  const [prod, setProd] = useState('');
  const [compname, setCompnameList] = useState('');
  const [insureList, setInsureList] = useState([]);
  const [insueComp, setInueCompList] = useState('');
  const [details, setDetails] = useState([]);
  const [logoUrl, setLogoUrl] = useState(hdfc);

  const [name, setName] = useState('');
  const [mob, setMob] = useState('');
  const [policyname, setPolicyname] = useState('');

  const usertoken = sessionStorage.getItem('tokens');

  const productArr = [
    {
      value: 'motor',
      label: 'Motor',
    },
    {
      value: 'health',
      label: 'Health',
    },
    {
      value: 'life',
      label: 'Life',
    },
  ];

  const handleSubmit = () => {
    InstanceWithAuth.post(CLAIM, {
      type: prod,
      insurer_name: name,
      policy_no: policyname,
      mobile_no: mob,
    })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title:
            'Claim assistance request registered, Our Client support executive will connect with you shortly',
          showConfirmButton: false,
          timer: 2500,
        });
        setName('');
        setMob('');
        setPolicyname('');
      })
      .catch(
        Swal.fire({
          icon: 'error',
          title: 'Please try again later',
          showConfirmButton: false,
          timer: 2500,
        })
      );
  };

  useEffect(() => {
    axios
      .get(
        `https://capi.preprod.eibpl.in/core/company_claimed_policy_details/?${compname}`,
        {
          headers: {
            Authorization: `Bearer ${usertoken}`,
          },
        }
      )
      .then((response) => {
        // setPost(response.data);

        setCompanyList(response.data);
        setDetails(response.data);
      });
    axios
      .get(
        `https://capi.preprod.eibpl.in/core/company_claimed_com_details/?policy_type=${compname}`,
        {
          headers: {
            Authorization: `Bearer ${usertoken}`,
          },
        }
      )
      .then((response) => {
        setInsureList(response.data);
      });

    // axios
    // .get(`https://capi.preprod.eibpl.in/core/company_claimed_policy_details/`,)
    // .then((response) => {
    //   // setPost(response.data);

    // });
  }, [compname, insueComp]);

  const handleSub = () => {
    axios
      .get(
        `https://capi.preprod.eibpl.in/core/company_claimed_details/?policy_type=${compname}&company_name=${insueComp}`,
        {
          headers: {
            Authorization: `Bearer ${usertoken}`,
          },
        }
      )
      .then((response) => {
        setDetails(response.data);
        setLogoUrl(response.data.map((i) => i.company_logo_url));
      });
  };

  return (
    <div className="w-full mt-12">
   <Helmet>
  <title>File a Claim | Insure Efficient Insurance Solutions</title>
  <meta
    name="description"
    content="Need to file an insurance claim? Insure Efficient makes the process easy and transparent. Get support for home, car, or life insurance claims today."
  />
</Helmet>
      <section
        // style={{ backgroundImage: `url(${people})` }}
        className=" relative    xl:h-[570px] justify-center items-center"
      >
        <div className="w-full md:w-1/2 ml-10" style={{ marginLeft: '12%' }}>
          <h2 className="text-4xl font-bold">File a Claim</h2>
          <img src={horizontal_blue_bar} alt="" className="my-4 w-20 h-2" />
        </div>
        <section>
          <div className="row-one">
            <div className="claim-row-one">
              <img src={first_image} />
            </div>

            <div className="upper-row">
              <div>
                <div className="upper-val">
                  <p>File a claim easily like never before!</p>
                </div>

                <p className="upper-desc">
                  Whoever your broker was, wherever you bought policy from, you
                  can easily claim it here!
                </p>

                <div className="upper-last">
                  <p
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '10px',
                    }}
                  >
                    <img src={mail} />
                    enquiry@iensure.in
                  </p>
                  <p
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '10px',
                    }}
                  >
                    <img src={call} />
                    7400063232
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <section>
        <div className="process-div">
          <div className="process-heading">
            <p>The Insure Process</p>
          </div>
          <div className="process-info">
            {[
              {
                src: box,
                name: 'Fill in your claim',
                desc: 'Request for your claim settlement to our agents.',
              },
              {
                src: card,
                name: 'Submit all your documents as needed by the claim team',
                desc: 'Submit all your documents that were used to take up the insurance policy.',
              },
              {
                src: relax,
                name: 'You may relax and our team will work for your claim settlement',
                desc: 'While the team is working, just wait until something ',
              },
            ].map((ele) => {
              return (
                <div style={{ textAlign: 'center', width: '22%' }}>
                  <div
                    style={{
                      display: 'flex',
                      textAlign: 'center',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '150px',
                    }}
                  >
                    <img
                      style={{ height: '150px' }}
                      className="process-img"
                      src={ele.src}
                    />
                  </div>
                  <div>
                    <p className="process-h1">{ele.name}</p>
                    <p className="process-desc">{ele.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section>
        <div className="third-block">
          <div className="third-block-text">
            <div>
              <div className="third-block-ques">
                <p>What it is ?</p>
              </div>
              <p className="third-block-desc">
                An insurance claim is a formal request by a policyholder to an
                insurance company for coverage or compensation for a covered
                loss or policy event. These incidents can include anything
                covered by your insurance policy, like a hospital stay, a
                natural disaster, or theft. The insurance company validates the
                claim (or denies the claim). If it is approved, the insurance
                company will issue payment to the insured or an approved
                interested party on behalf of the insured.
              </p>
            </div>
          </div>
          <div className="third-block-img">
            <img src={insurance_image} />
          </div>
        </div>
      </section>
      <section>
        <div>
          <img src={banner} />
        </div>
      </section>
      <section>
        <div className="claim-form">
          <div>
            <p className="claim-form-name">
              Share details for raising claim request
            </p>
            <div className="claim-form-card">
              <div className="flex flex-col gap-y-3 mt-8 py-8 px-8">
                <label>
                  <b>Select type of insurance</b>
                </label>
                <Select
                  options={productArr}
                  onChange={(e) => setProd(e.value)}
                />
                <input
                  placeholder="Enter the insurer name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  type="text"
                  className="w-full text-slate-900 border-[1px] rounded-lg px-4 py-2 border-slate-300"
                />
                <input
                  placeholder="Enter the policy number"
                  value={policyname}
                  onChange={(e) => {
                    setPolicyname(e.target.value);
                  }}
                  type="text"
                  className="w-full  border-[1px] rounded-lg px-4 py-2 border-slate-300"
                />
                <input
                  placeholder="Enter the mobile number"
                  value={mob}
                  onChange={(e) => {
                    setMob(e.target.value);
                  }}
                  type="number"
                  className="w-full border-[1px] rounded-lg px-4 py-2 border-slate-300"
                />
              </div>
              {/* <div className="flex justify-center h-11 md:flex-none">
                <ReCAPTCHA sitekey="DATA_KEY" onChange={() => {}} />
              </div> */}
              <div className="flex justify-center md:flex-none py-4">
                <button
                  onClick={handleSubmit}
                  className="h-10 w-100 bg-blue-900 px-8 py-1 rounded-xl text-white text-sm"
                >
                  Submit Claim Request
                </button>
              </div>
            </div>
          </div>

          <div>
            <p className="claim-form-name">Request Claim Assistance</p>
            <div className="claim-form-card" style={{ width: '700px' }}>
              <div className="flex flex-row gap-x-3 mt-8 py-8 px-8">
                <div style={{ width: '50%' }}>
                  <label>
                    <b>Product</b>
                  </label>
                  <Select
                    options={productArr}
                    onChange={(e) => setCompnameList(e.value)}
                  />
                </div>

                <div style={{ width: '50%' }}>
                  <label>
                    <b>Insurer </b>
                  </label>
                  <Select
                    options={insureList}
                    onChange={(e) => setInueCompList(e.value)}
                  />
                </div>

                <button
                  onClick={handleSub}
                  className="h-10 bg-blue-900 px-8 py-1 mt-5 rounded-xl text-white text-sm"
                >
                  Submit
                </button>
              </div>
              <div className="flex justify-center md:flex-none">
                <img
                  style={{ width: '100px' }}
                  src={logoUrl}
                  // details.map((i) => i.company_logo_url)
                  //   ? details.map((i) => i.company_logo_url)
                  //   : ''
                />
              </div>
              <div className="flex py-2 justify-center md:flex-none">
                <b>{details.map((i) => i.company_name)}</b>
              </div>
              <div className="flex justify-center md:flex-none">
                <p>
                  <span style={{ fontWeight: '600' }}> Email :</span>{' '}
                  {details.map((i) => i.claim_email)}
                </p>
              </div>
              <div className="flex py-2 justify-center md:flex-none">
                <p>
                  <span style={{ fontWeight: '600' }}>Contact us :</span>
                  {details.map((i) => i.claim_contact_no)}
                </p>
              </div>
              <div className="flex justify-center  md:flex-none">
                <a href={details.map((i) => i.claim_url)}>
                  <span style={{ fontWeight: '600' }}>
                    {details.map((i) => i.company_name)} Claim Service Link{' '}
                  </span>
                  {/* {details.map((i) => i.claim_url)} */}
                </a>
              </div>
              {/* <div className="flex justify-center md:flex-none py-4">
                <button className="h-10 w-100 bg-blue-900 px-8 py-1 rounded-xl text-white text-sm">
                  Submit Claim Request
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="h-[60px]">
          <div></div>
        </div>
      </section>
    </div>
  );
}

export default Claim;
